export function generarFirmaDesdeContexto({ flujoActivo, utmData = {}, contextData = {}, secret = 'claveSecreta123' }) {
  const mpOrigen = flujoActivo?.mp_origen || sessionStorage.getItem('mp_origen') || '';
  const tipoFlujo = flujoActivo?.tipo_flujo || sessionStorage.getItem('tipo_flujo') || '';
  const base = `${mpOrigen}${tipoFlujo}${secret}`;
  const firma = btoa(unescape(encodeURIComponent(base)));

  return {
    firma,
    mpOrigen,
    tipoFlujo,
    urlRedireccion: `/IndexPac?mp_origen=${mpOrigen}&tipo_flujo=${tipoFlujo}&firma=${firma}`,
    utmData: {
      source: utmData.source || sessionStorage.getItem('utm_source') || '-',
      medium: utmData.medium || sessionStorage.getItem('utm_medium') || '-',
      campaign: utmData.campaign || sessionStorage.getItem('utm_campaign') || '-',
      term: utmData.term || sessionStorage.getItem('utm_term') || '-',
      content: utmData.content || sessionStorage.getItem('utm_content') || '-',
    },
    dispositivo: {
      tipo: contextData.dispositivoTipo || navigator.userAgent || '-',
      navegador: contextData.navegador || navigator.vendor || '-',
      sistemaOperativo: contextData.sistemaOperativo || navigator.platform || '-',
    }
  };
}